<ion-header class="ion-no-border app-inner-padding">
	<ion-grid class="ion-no-padding">
		<ion-row class="ion-no-padding">
			<ion-col size="8">
				<ion-title size="small" class="ion-no-padding">{{
					'connectionsModal.pageTitle' | translate
				}}</ion-title>
			</ion-col>
			<ion-col size="4">
				<ion-buttons>
					<ion-button class="ion-no-padding" (click)="close()">
						<ion-icon class="icon-Close"></ion-icon>
					</ion-button>
				</ion-buttons>
			</ion-col>
		</ion-row>
	</ion-grid>
</ion-header>
<ion-content class="inner-content app-inner-padding">
	<ng-container [ngSwitch]="activeComponent">
		<app-connections-list
			*ngSwitchCase="connectionsModalComponentsEnum.listOfConnections"
			[connectionType]="connectionType"
		></app-connections-list>
		<app-connections-add-edit
			*ngSwitchCase="connectionsModalComponentsEnum.addManuallyConnection"
			[connectionType]="connectionType"
		></app-connections-add-edit>
		<app-connections-add-edit
			*ngSwitchCase="connectionsModalComponentsEnum.editConnection"
			[connectionType]="connectionType"
			[connectionId]="connectionId"
		></app-connections-add-edit>
		<app-connections-qr-code
			*ngSwitchCase="connectionsModalComponentsEnum.addQrCodeConnection"
			[connectionType]="connectionType"
		></app-connections-qr-code>
		<app-connection-options
			*ngSwitchCase="connectionsModalComponentsEnum.optionsConnection"
			[connectionId]="connectionId"
			[connectionType]="connectionType"
			[isEditMode]="false"
			(confirmAction)="confirmAction()"
		></app-connection-options>
		<app-connection-options
			*ngSwitchCase="connectionsModalComponentsEnum.editOptionsConnection"
			[connectionId]="connectionId"
			[connectionType]="connectionType"
			[isEditMode]="true"
			(confirmAction)="confirmAction()"
		></app-connection-options>
	</ng-container>
</ion-content>
<ion-footer class="ion-no-border"></ion-footer>
